module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-page"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.currentSpace
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-page__main"
  }, [_vm._l((_vm.page.layout), function(card) {
    return [(typeof _vm.cards[card.id] !== 'undefined') ? _c('card-' + _vm.cards[card.id].type, {
      key: card.id,
      tag: "component",
      attrs: {
        "card": _vm.cards[card.id]
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa28d702"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Page.vue
// module id = 569
// module chunks = 1